import React from 'react';
import MobileAdV6HeroSection from '../components/MobileAdV6HeroSection';

const MobileAdV6Page = () => {
  return (
    <div className="min-h-screen bg-slate-950">
      <MobileAdV6HeroSection />
    </div>
  );
};

export default MobileAdV6Page;
